import { useEffect } from "react";
import { createPortal } from "react-dom";
import { Phone, X } from "lucide-react";
import { NAV, PHONE_DISPLAY, PHONE_HREF } from "./content";

export const MobileNav = ({ open, onClose, Logo }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;
  return createPortal(
    <div id="mobile-nav" role="dialog" aria-modal="true" aria-label="Meny" className="fixed inset-0 z-50 flex flex-col overflow-y-auto bg-white lg:hidden" data-testid="mobile-nav-panel">
      <div className="flex h-16 shrink-0 items-center justify-between border-b border-[var(--line)] px-4 sm:px-6">
        <Logo className="h-10 w-auto" />
        <button type="button" onClick={onClose} aria-label="Stäng meny" className="grid h-11 w-11 place-items-center rounded-full hover:bg-[var(--sand)]" data-testid="mobile-nav-close">
          <X size={24} aria-hidden />
        </button>
      </div>
      <nav aria-label="Mobilmeny" className="flex flex-col px-4 py-4 sm:px-6">
        {NAV.map((n) => (
          <a key={n.id} href={`#${n.id}`} onClick={onClose} data-testid={`mobile-nav-link-${n.id}`} className="font-display flex min-h-[52px] items-center border-b border-[var(--line)] text-xl font-semibold">
            {n.label}
          </a>
        ))}
      </nav>
      <div className="mt-auto grid gap-3 px-4 pb-8 pt-2 sm:px-6">
        <a href="#offert" onClick={onClose} className="btn btn-red" data-testid="mobile-nav-quote-button">Begär offert</a>
        <a href={PHONE_HREF} onClick={onClose} className="btn btn-outline" data-testid="mobile-nav-call-button">
          <Phone size={18} aria-hidden /> Ring oss · {PHONE_DISPLAY}
        </a>
      </div>
    </div>,
    document.body
  );
};
